import React, { FC } from 'react';

// = Styles =
import classes from './split-content.module.scss';
import clsx from 'clsx';

// = Types =
interface SplitContentInterface {
  SideBar: React.ReactElement;
  Content: React.ReactElement;
  Position?: boolean;
}

const SplitContent: FC<SplitContentInterface> = ({ SideBar, Content, Position = false }) => {
  if (Position) {
    return (
      <div
        className={clsx({
          [classes['container']]: true,
          [classes['container__position--right']]: Position,
        })}>
        <>{Content}</>
        <>{SideBar}</>
      </div>
    );
  }
  return (
    <div
      className={clsx({
        [classes['container']]: true,
        [classes['container__position--left']]: !Position,
      })}>
      <>{SideBar}</>
      <>{Content}</>
    </div>
  );
};

export { SplitContent };
